import { render, staticRenderFns } from "./GroupBuyList.vue?vue&type=template&id=b1871026&scoped=true&"
import script from "./GroupBuyList.vue?vue&type=script&lang=js&"
export * from "./GroupBuyList.vue?vue&type=script&lang=js&"
import style0 from "./GroupBuyList.vue?vue&type=style&index=0&id=b1871026&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1871026",
  null
  
)

export default component.exports